import { api } from './api';
import { PayoutDetailResponse, PayoutListFilters, PayoutListResponse, PayoutSyncResponse } from '../types/payouts';

/**
 * Spec 053 Phase 2 — Stripe payouts (billing `AdminPayoutController`, gateway route
 * `billing-admin-payouts`, screen `finance`). Read-only apart from `sync`, which asks billing to
 * refresh the balance snapshot and the payout list from Stripe right now instead of waiting for the
 * nightly sweep (Flow C2: "Stripe API unavailable → Stripe cards show last snapshot time").
 */
export const payoutsApi = {
  list: (filters: PayoutListFilters, token: string) => {
    const query = new URLSearchParams();
    if (filters.from) query.set('from', filters.from);
    if (filters.to) query.set('to', filters.to);
    if (filters.status) query.set('status', filters.status);
    const qs = query.toString();
    return api.get<PayoutListResponse>(`/api/admin/payouts${qs ? `?${qs}` : ''}`, token);
  },

  /** `payoutId` is billing's UUID (`PayoutSummaryResponse.payoutId`), not the Stripe `po_…` id. */
  get: (payoutId: string, token: string) =>
    api.get<PayoutDetailResponse>(`/api/admin/payouts/${encodeURIComponent(payoutId)}`, token),

  /**
   * Takes a fresh balance snapshot and ingests any payouts the webhooks missed. Billing answers 202
   * even when Stripe was unreachable — then `snapshotTakenAt` is null and the caller must say so
   * rather than report success; 503 only when Stripe is disabled on the environment.
   */
  sync: (token: string) =>
    api.post<PayoutSyncResponse>('/api/admin/payouts/sync', undefined, token),
};
